<template>
  <section class="product-benefit-summary">
    <h2>{{ $t('productCommon.benefitSummary') }}</h2>
    <div class="product-benefit-summary__card">
      <div class="product-benefit-summary__item"><img src="@/assets/img/product/online-process.svg" alt=""><span>{{ $t('productCommon.onlineProcess') }}</span></div>
      <i aria-hidden="true"></i>
      <div class="product-benefit-summary__item"><span class="product-benefit-summary__bolt" aria-hidden="true">⚡</span><span>{{ $t('productCommon.lightInstallments') }}</span></div>
      <i aria-hidden="true"></i>
      <div class="product-benefit-summary__item"><img src="@/assets/img/product/no-credit-card.svg" alt=""><span>{{ $t('productCommon.noCreditCard') }}</span></div>
    </div>
  </section>
</template>
<script>
export default { name: 'ProductBenefitSummary' };
</script>
<style lang="less" scoped>
.product-benefit-summary { padding: 24px 0 32px; color: #070D3F;
  h2 { margin: 0 0 16px; font-size: 26px; font-weight: 500; line-height: 36px; }
  &__card { display: flex; align-items: center; min-height: 86px; padding: 16px 12px; border: 2px solid #E5EAF3; border-radius: 20px; background: #fff; }
  &__item { display: flex; flex: 1 1 0; align-items: center; justify-content: center; min-width: 0; padding: 0 8px; font-size: 22px; font-weight: 400; line-height: 28px;
    img, .product-benefit-summary__bolt { flex: 0 0 auto; width: 32px; height: 32px; margin-right: 8px; color: #174DFF; font-size: 28px; line-height: 32px; }
    span { display: -webkit-box; overflow: hidden; -webkit-box-orient: vertical; -webkit-line-clamp: 2; }
  }
  i { flex: 0 0 1px; height: 56px; background: #D8E2F2; }
}
</style>
